/**
 * Created by luka on 23.02.2018.
 */

import {
    DECLINE_PAYOUT_LOADING, DECLINE_PAYOUT_SUCCESS, LOADING_DECLINE_PAYOUT_FAILED, LOADING_REQUEST_PAYOUT_FAILED,
    REQUEST_PAYOUT_LOADING,
    REQUEST_PAYOUT_SUCCESS
} from "../actions/types";
export function loadingRequestPayoutFailed(state = false, action) {
    switch (action.type) {
        case LOADING_REQUEST_PAYOUT_FAILED:
            return action.error;
        default:
            return state;
    }
}
export function requestPayoutLoading(state = false, action) {
    switch (action.type) {
        case REQUEST_PAYOUT_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function requestPayoutSuccess(state = {}, action) {
    switch (action.type) {
        case REQUEST_PAYOUT_SUCCESS:
            return action.response;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/payout/RequestPayoutReducer.js